/**
 * External dependencies
 */
import React from "react";
import classNames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";
import { IoClose, IoMenu } from "react-icons/io5";
import logo from "assets/images/logo_white.png";

import "./styles.scss";

import { useMediaQuery } from "react-responsive";

/**
 * Internal dependencies
 */

export default function Topbar({
  children,
  mobileChildren,
  className,
  ...rest
}) {
  const isMobile = useMediaQuery({ maxWidth: "1150px" });
  const [isMenuOpen, setShowMenu] = React.useState(false);

  const toggleMenu = () => {
    setShowMenu(!isMenuOpen);
  };

  const classes = classNames("topbar", className);

  return (
    <header className="header">
      <Box className={classes} padding="xlarge" {...rest}>
        {isMobile ? (
          <div
            className={`topbar__menu  ${isMenuOpen ? "show-menu" : ""}`}
            id="topbar-menu"
          >
            <div
              className="topbar__toggle"
              id="topbar-toggle"
              onClick={toggleMenu}
            >
              <IoClose />
            </div>
            <Box className="topbar__menu-inner">
              {mobileChildren ?? children}
            </Box>
          </div>
        ) : (
          <Box className="topbar__menu-inner">{children}</Box>
        )}
        {isMobile && (
          <div className="topbar__mobile-content-wrapper">
            <img
              src={logo}
              alt="Logo"
              style={{ height: 40, marginRight: 25 }}
            />
            <div
              className="topbar__toggle"
              id="topbar-toggle"
              onClick={toggleMenu}
            >
              <IoMenu />
            </div>
          </div>
        )}
      </Box>
    </header>
  );
}
